import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { SystemState } from '@/store/modules/system/index';
import {
  FORMS_FILTERS,
  LOGIN_PENDING,
  OPEN_TERMS_AND_PRIVACY_MODAL,
  PROCESS_COMPARE_REQUEST,
  PROCESS_COMPARE_REQUESTS_ERRORS,
  PROCESS_COMPARE_REQUESTS_LOADING,
  QUARTZ_INFO,
  RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS,
  RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS,
  RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS,
  SYSTEM_CACHE_LIST,
  SYSTEM_ERRORS,
  SYSTEM_JOB_LOG,
  SYSTEM_JOBS_ERRORS,
  SYSTEM_JOBS_LOGS_LIST,
  SYSTEM_QUARTZ_ERRORS,
  SYSTEM_STATISTICS_ERRORS,
  TEST_MAILS_ERRORS,
  TOKEN,
} from '@/types/system.types';
import { QuartzInfo } from '@/models/system/QuartzInfo';
import { FormsFiltersModel } from '@/models/system/FormsFilters';
import { ProcessCompareRequest } from '@/models/system/process-compare-request';

export const getters: GetterTree<SystemState, RootState> = {

  [TOKEN](state): string {
    return state.token;
  },

  [SYSTEM_ERRORS](state): string[] {
    return state.systemErrors;
  },

  [SYSTEM_QUARTZ_ERRORS](state): string[] {
    return state.systemQuartzErrors;
  },

  [SYSTEM_JOBS_ERRORS](state): string[] {
    return state.systemJobsErrors;
  },

  [SYSTEM_STATISTICS_ERRORS](state): string[] {
    return state.systemStatisticsErrors;
  },

  [LOGIN_PENDING](state): boolean {
    return state.loginPending;
  },

  [SYSTEM_CACHE_LIST](state): string[] {
    return state.systemCacheList;
  },

  [SYSTEM_JOBS_LOGS_LIST](state): string[] {
    return state.systemJobsLogsList;
  },

  [SYSTEM_JOB_LOG](state): string[] {
    return state.systemJobLog;
  },

  [QUARTZ_INFO](state): QuartzInfo {
    return state.quartzInfo;
  },

  [FORMS_FILTERS](state): FormsFiltersModel {
    return state.formsFilters;
  },

  [RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS](state): string[] {
    return state.runForm101PdfGeneratorJobErrors;
  },

  [RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS](state): string[] {
    return state.runForm101PdfFilesExportJobErrors;
  },

  [RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS](state): string[] {
    return state.runForm101PdfComsignJobErrors;
  },

  [TEST_MAILS_ERRORS](state): string[] {
    return state.testMailsErrors;
  },

  [PROCESS_COMPARE_REQUEST](state): ProcessCompareRequest {
    return state.processCompareRequest;
  },

  [PROCESS_COMPARE_REQUESTS_ERRORS](state): string[] {
    return state.processCompareRequestsErrors;
  },

  [PROCESS_COMPARE_REQUESTS_LOADING](state): boolean {
    return state.processCompareRequestsLoading;
  },

  [OPEN_TERMS_AND_PRIVACY_MODAL](state): boolean {
    return state.openTermsAndPrivacyModal;
  },

};
